import React from "react";
import LoginForm from "../../components/auth-pages/login-page/LoginForm";



const Login = () => {
  return (
    <>
      <LoginForm />
    </>
  );
};

export default Login;
